import type { ScreenModule } from "../../../app/screen-module";
import { ProgressListPage } from "../ProgressPages";

export default {
	id: "end-user.progress",
	path: "/app/progress",
	area: "end-user",
	navGroup: "確認する",
	label: "進捗",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: ProgressListPage,
} satisfies ScreenModule;
